import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ErrorTrustedService {
    public isError: Subject<any> = new Subject();
}
